(function () {
    'use strict';

    angular
        .module('ib-passenger-docs-module')
        .controller('PassengerDocsController', PassengerDocsController);

    PassengerDocsController.$inject = ['ApisFormConstants', '$scope', 'localStorageService'];
    function PassengerDocsController (ApisFormConstants, $scope, localStorageService) {
        const vm = this;

        vm.$onInit = activate;
        vm.isDocCountryDisabled = isDocCountryDisabled;
        vm.deleteDocument = deleteDocument;
        vm.changeDocumentEvent = changeDocumentEvent;
        vm.changeDocument = changeDocument;

        $scope.$on('changeDocument', changeDocument);

        ////////////////

        function activate () {
            selectLoggedDocument();
        }


        /**
         * Select on int document logged if have it and only is one
         */
        function selectLoggedDocument () {
            const counterLogged = [], isFirstTime = localStorageService.get('counterDocs');

            if (!isFirstTime) {
                for (let i = 0; i < vm.pasDocsData.documents.length; i++) {
                    if (vm.pasDocsData.documents[i].isSaved) {
                        counterLogged.push(vm.pasDocsData.documents[i]);
                    }
                }

                if (counterLogged.length === 1) {
                    vm.pasDocsData.selectedDoc = counterLogged[0];
                }

                localStorageService.set('counterDocs', true);
            }
        }

        /**
         * Emits event to componente expiry date for clean model
         */
        function changeDocumentEvent () {
            $scope.$broadcast('refreshModelEvent');
        }

        function isDocCountryDisabled () {
            return vm.pasDocsData.selectedDoc.type.code === ApisFormConstants.DOCUMENT_TYPES.GREENCARD
                || vm.pasDocsData.selectedDoc.type.code === ApisFormConstants.DOCUMENT_TYPES.REDRESSNUMBER
                || vm.pasDocsData.selectedDoc.type.code === ApisFormConstants.DOCUMENT_TYPES.KNOWNTRAVELERNUMBER;
        }


        /**
         * Upadate select document to first in array when delete one of list
         */
        function changeDocument () {
            vm.pasDocsData.selectedDoc = vm.pasDocsData.documents[0];
        }

        /**
         * Emit event for delete document
         * @param {Object} document Element selected for delete
         */
        function deleteDocument (document) {
            $scope.$emit('deleteDocument', document);
        }


    }
})();
